module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "编辑作品信息"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "userVideoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.userVideoParams,
      "rules": _vm.userVideoRules,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', [_vm._v("\n          学生：" + _vm._s(_vm.userVideoParams.uid) + "-" + _vm._s(_vm.userVideoParams.nickname) + "\n        ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.userVideoParams.title),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "title", $$v)
      },
      expression: "userVideoParams.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分组",
      "prop": "ageGroup"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.userVideoParams.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "ageGroup", _vm._n($$v))
      },
      expression: "userVideoParams.ageGroup"
    }
  }, _vm._l((_vm.$constant.userVideoType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生作品",
      "prop": "videoUrl"
    }
  }, [_c('el-upload', {
    ref: "videoUpload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.videoChange,
      "on-success": _vm.videoSuccess,
      "on-error": _vm.handleUploadError,
      "on-exceed": _vm.videoExceed,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "disabled": !_vm.formReady,
      "accept": "video/*",
      "limit": 1,
      "file-list": _vm.videoFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.formReady
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品封面",
      "prop": "videoPicUrl"
    }
  }, [_c('el-upload', {
    ref: "videoPicUpload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.videoPicChange,
      "on-success": _vm.videoPicSuccess,
      "on-error": _vm.handleUploadError,
      "on-exceed": _vm.videoPicExceed,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "disabled": !_vm.formReady,
      "accept": "image/*",
      "limit": 1,
      "file-list": _vm.videoPicFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.formReady
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抖音链接",
      "prop": "douyinUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "抖音分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.douyinUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "douyinUrl", $$v)
      },
      expression: "userVideoParams.douyinUrl"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "size": "small",
      "disabled": !(_vm.userVideoParams.douyinUrl || '').trim() || _vm.loadingFetch
    },
    on: {
      "click": function($event) {
        return _vm.fetchShortVideo('douyin')
      }
    },
    slot: "append"
  }, [_vm._v("抓取")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "小红书链接",
      "prop": "xhsUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "小红书分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.xhsUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "xhsUrl", $$v)
      },
      expression: "userVideoParams.xhsUrl"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "size": "small",
      "disabled": !(_vm.userVideoParams.xhsUrl || '').trim() || _vm.loadingFetch
    },
    on: {
      "click": function($event) {
        return _vm.fetchShortVideo('xhs')
      }
    },
    slot: "append"
  }, [_vm._v("抓取")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "视频号链接",
      "prop": "channelsUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "视频号分享链接或文案"
    },
    model: {
      value: (_vm.userVideoParams.channelsUrl),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "channelsUrl", $$v)
      },
      expression: "userVideoParams.channelsUrl"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "size": "small",
      "disabled": !(_vm.userVideoParams.channelsUrl || '').trim() || _vm.loadingFetch
    },
    on: {
      "click": function($event) {
        return _vm.fetchShortVideo('channels')
      }
    },
    slot: "append"
  }, [_vm._v("抓取")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.userVideoParams.svSyncStatus != null) ? _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "同步状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.syncStatusText))]), _vm._v(" "), (_vm.userVideoParams.svAuthor) ? _c('span', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("作者：" + _vm._s(_vm.userVideoParams.svAuthor))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("合计 赞" + _vm._s(_vm.userVideoParams.svLikeCount || 0) + " / 藏" + _vm._s(_vm.userVideoParams.svCollectCount || 0) + " / 评" + _vm._s(_vm.userVideoParams.svCommentCount || 0))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.svTasks.length) ? _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "平台抓取"
    }
  }, _vm._l((_vm.svTasks), function(task) {
    return _c('div', {
      key: task.platform
    }, [_c('span', [_vm._v(_vm._s(_vm.platformText(task.platform)) + "：" + _vm._s(_vm.taskStatusText(task.status)))]), _vm._v(" "), (task.author) ? _c('span', {
      staticStyle: {
        "margin-left": "12px"
      }
    }, [_vm._v("作者：" + _vm._s(task.author))]) : _vm._e(), _vm._v(" "), (task.coverUrl) ? _c('viewer', {
      staticStyle: {
        "display": "inline-block",
        "margin-left": "12px",
        "vertical-align": "middle"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "28px",
        "height": "28px",
        "object-fit": "cover",
        "cursor": "pointer",
        "vertical-align": "middle"
      },
      attrs: {
        "src": _vm.mediaUrl(task.coverUrl),
        "alt": "封面"
      }
    })]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "12px"
      }
    }, [_vm._v("赞" + _vm._s(task.likeCount || 0) + " / 藏" + _vm._s(task.collectCount || 0) + " / 评" + _vm._s(task.commentCount || 0))]), _vm._v(" "), (task.status === 'fail' && task.errorMsg) ? _c('span', {
      staticStyle: {
        "margin-left": "12px",
        "color": "#ed4014"
      }
    }, [_vm._v("失败原因：" + _vm._s(task.errorMsg))]) : _vm._e()], 1)
  }), 0)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning",
      "size": "large",
      "loading": _vm.loadingFetch
    },
    on: {
      "click": function($event) {
        return _vm.fetchShortVideo()
      }
    }
  }, [_vm._v("全部抓取")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditModal,
      "disabled": !_vm.formReady
    },
    on: {
      "click": _vm.editUserVideo
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfdfda94","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/modal/EditUserVideoModal.vue
// module id = 1960
// module chunks = 8